module.exports = __webpack_public_path__ + "img/9788962381122.b341d551.jpg";